<script setup>
defineProps({ task: { type: String, required: true } })
</script>

<template>
  <details class="rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-text)]">
    <summary class="cursor-pointer px-4 py-3 text-sm font-semibold">{{ $t(`ux.guides.${task}.title`) }}</summary>
    <ol class="list-decimal space-y-2 pb-4 pl-10 pr-4 text-sm text-[var(--color-muted)]">
      <li v-for="step in 3" :key="step">{{ $t(`ux.guides.${task}.step${step}`) }}</li>
    </ol>
  </details>
</template>
